import * as Types from "../../graphql/schemaTypes.generated";

import { ActualBalancesFieldsFragment } from "./ActualBalancesFields.generated";
import gql from "graphql-tag";
import { ActualBalancesFieldsFragmentDoc } from "./ActualBalancesFields.generated";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateActualBalanceMutationVariables = Types.Exact<{
  id: Types.Scalars["Int"];
  interest_rate: Types.Scalars["numeric"];
}>;

export type UpdateActualBalanceMutation = { __typename?: "mutation_root" } & {
  update_actual_balances?: Types.Maybe<
    { __typename?: "actual_balances_mutation_response" } & {
      returning: Array<
        { __typename?: "actual_balances" } & ActualBalancesFieldsFragment
      >;
    }
  >;
};

export const UpdateActualBalanceDocument = gql`
  mutation UpdateActualBalance($id: Int!, $interest_rate: numeric!) {
    update_actual_balances(
      where: { id: { _eq: $id } }
      _set: { interest_rate: $interest_rate }
    ) {
      returning {
        ...actualBalancesFields
      }
    }
  }
  ${ActualBalancesFieldsFragmentDoc}
`;

export function useUpdateActualBalanceMutation() {
  return Urql.useMutation<
    UpdateActualBalanceMutation,
    UpdateActualBalanceMutationVariables
  >(UpdateActualBalanceDocument);
}
